import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import AuthService from '../services/AuthService.js';
import Loader from './loader';

const ProtectedRoute = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(null);
    const [isChecking, setIsChecking] = useState(true);
    const location = useLocation();

    useEffect(() => {
        const checkAuth = async () => {
            setIsChecking(true);
            
            try {
                const token = localStorage.getItem('token');
                if (!token) {
                    setIsAuthenticated(false);
                    setIsChecking(false);
                    return;
                }

                // Verify token with server only once
                const isValid = await AuthService.verify();
                
                setIsAuthenticated(isValid);
                
                if (!isValid) {
                    // Clear invalid token
                    localStorage.removeItem('token');
                    localStorage.removeItem('premo_password');
                }
            } catch (error) {
                console.error('ProtectedRoute: Auth check failed:', error);
                setIsAuthenticated(false);
                localStorage.removeItem('token');
                localStorage.removeItem('premo_password');
            } finally {
                setIsChecking(false);
            }
        };

        // Only check auth on mount, not periodically to avoid infinite loops
        checkAuth();
    }, []);

    // Prevent redirect loop
    if (isChecking) {
        return <Loader />;
    }

    if (!isAuthenticated) {
        // Only redirect if we're not already on the login page
        if (location.pathname !== '/login') {
            return <Navigate to="/login" replace />;
        }
        return <Navigate to="/login" replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;
